// add a fonction to generate unique id in pure js
// don't import any library nor vue.js

// generate a random string
// and export the function

export function useUniqueId() {
    return Math.random().toString(36).substr(2, 9);
    }
